import DealProductType from '@v/bookings/edit/models/DealProductType.js'

const getQuantityInProductGroup = v => {
  const quantityInDeal = v.productGroupProductQuantity || v.quantityInProductGroup
  return parseInt(quantityInDeal) || 1
}

const getDealProductType = v => {
  if (v.dealProductType) return v.dealProductType
  if (v.productGroupKey) return DealProductType.DealProduct
  return DealProductType.NotSet
}

export const makeBookingProduct = value => ({
  ProductGroupKey: value.productGroupKey || null,
  ProductGroupName: value.productGroupName || null,
  ProductGroupProductKey: value.productGroupProductKey || null,
  ResourceKey: value.resourceKey || value.product.ResourceKey,
  FromDateTimeUTC: value.fromDateTimeUTC,
  ProductKey: value.product.Key,
  ProductName: value.product.NameInternal,
  NeedsToBeScheduled: value.product.NeedsToBeScheduled,
  ProductQuantity: 0,
  QuantityInProductGroup: getQuantityInProductGroup(value),
  QuantitiesPerClassification: [],
  DealProductType: getDealProductType(value),
  isSegmentless: !(value.product.ActiveSegments && value.product.ActiveSegments.length > 0),
})
